import { observer } from 'mobx-react-lite';
import Layout from '../Layout/Layout';
import { Box, Grid } from '@mui/material';
import SearchInput from './SearchInput';
import SearchOptions from './SearchOptions';
import SearchResults from './SearchResults';
import SearchQueryViewer from './SearchQueryViewer';

const SearchBarPage = observer(() => {
    return (
        <div className="SearchBarPage">
            <Layout tools={[]} drawerTools={[]}>
                <Box
                    sx={{
                        height: `calc(100vh - 50px)`,
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: '#1976d2',
                        px: 0.5,
                        py: 0,
                    }}
                >
                    <Box mb={0.5} sx={{ flexShrink: 0 }}>
                        <SearchInput />
                    </Box>

                    <Box sx={{ flex: 1, minHeight: 0 }}>
                        <Grid container spacing={0.5} sx={{ height: '100%' }}>
                            <Grid item md={2} sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, height: '100%' }}>
                                <SearchOptions />
                            </Grid>
                            <Grid item md={3.5} sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, height: '100%' }}>
                                <SearchQueryViewer />
                            </Grid>
                            <Grid item md={6.5} sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, height: '100%' }}>
                                <SearchResults />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Layout>
        </div>
    );
});

export default SearchBarPage;
